import { AVAILABLE_DRIVERS_CLASS, DataManagerComponent, DataManagerConfiguration, LoggerUtilsComponent } from '@proteo/core';
import { Param } from '../models/param.model';
import { ResponseParams, ResponseParamsWrapped } from '../models/responses.model';
import { Stage } from '../models/stage.model';
import { getSharedConfig } from '../services/portal-services';
import { TokenService } from './token.service';

export class ParamsService {
  private token: string;
  constructor(private tokenService: TokenService) {}

  /**
   *
   * @param product
   * @returns
   */
  async getParams(product: string): Promise<ResponseParamsWrapped> {
    await this.changeDriver('HTTP');
    this.token = await this.tokenService.getToken();

    if (this.token !== null) {
      await this.changeDriver('P4');

      DataManagerComponent.getInstance().setAuthorization({ OAUTH: this.token, OIDC: '' });

      const params: Record<string, string> = {
        product: product
      };

      try {
        const response = await DataManagerComponent.getInstance().get<ResponseParams>('mobile-app/api-onboarding-bff/v0/params', null, params);
        LoggerUtilsComponent.getInstance().debug('[param.service] params response: ', response);
        return {
          data: {
            params: Param.createMap(response.data.params),
            stages: Stage.createMap(response.data.stages)
          }
        };
      } catch (error) {
        LoggerUtilsComponent.getInstance().debug('[param.service] params error: ', error);
        return null;
      }
    }
  }

  /**
   * Change driver if call token
   */
  async changeDriver(driver: string): Promise<void> {
    const config = getSharedConfig('LANDING');
    const dataManagerConf: DataManagerConfiguration = {
      driver: AVAILABLE_DRIVERS_CLASS[driver],
      host: config.portalConfig.REST_CONFIG.HOST,
      baseUrl: config.portalConfig.REST_CONFIG.BASE_PATH
    };

    DataManagerComponent.initInstance(dataManagerConf);
  }
}
